module.exports = __webpack_public_path__ + "img/plan11.96699971.svg";